import React from "react";
import { Chip, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useDispatch } from "react-redux";
import {
  handleAppSelectedTopic,
  handleAppSelectedTopicToSaveMsg,
  handleAppSelectedSubtopic,
  handleAppSelectedSubtopicToSaveMsg,
  handleScrollToBottom,
  handleStarMsgScreen,
} from "../../../appStore/actions/AppState/action";
import { handleFetchMessages } from "../../../appStore/actions/ArkchatGroup/action";
import useAppSelectors from "../../../customHooks/useAppSelectors"
import { ChatSearchButton, SmallIcon } from "../../../common/chatComponents/ScreenSearchSection";
import searchIcon from "../../../assets/images/chats/searchIcon.svg";
import blackCrossIcon from "../../../assets/images/chats/blackCrossIcon.svg"
import closeLogo from "../../../assets/images/chats/closeLogo.svg"
import { colorSchemes, fontSizeSchemes } from "../../../assets/commonFunction";
import { useTranslation } from "react-i18next";

const GroupInfoHeader = ({ setMediaFilesOpen,handleBacktoMessage,handleSearch, transparent = false, isPreviewOpen = false, onClosePreview }) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const appContent = t("AppContent", {
    returnObjects: true,
  });
  const { selectedGroup, selectedTopic, selectedSubtopic, showStarMessage } = useAppSelectors();

  const handleDelete = () => {
    dispatch(handleAppSelectedTopic(null));
    dispatch(handleAppSelectedTopicToSaveMsg(null));
    dispatch(handleAppSelectedSubtopic(null));
    dispatch(handleAppSelectedSubtopicToSaveMsg(null));
    dispatch(handleFetchMessages(selectedGroup?.pnId, null));
  };
  const handleRemoveStarScreen = () => {
    dispatch(handleStarMsgScreen(!showStarMessage));
    dispatch(handleFetchMessages(selectedGroup?.pnId, selectedTopic?.id));
    dispatch(handleScrollToBottom(true));
  };
  return (
    <Stack
      width={"100%"}
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{
        padding: "0rem 0.25rem",
        backgroundColor: transparent ? "transparent" : "#E1E1E1",
        height: "1.8rem",
      }}
    >
      <Stack
          justifyContent={"flex-start"}
          spacing={"0.25rem"}
          width={"100%"}
          direction={"row"}
          alignItems={"center"}
        >
          <Box maxWidth="50%">
            <Typography
              sx={{
                fontSize: fontSizeSchemes.font16,
                fontWeight: 400,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "left",
              }}
              title={`${selectedGroup?.name}${
                selectedGroup?.isBuyerSellerGroup ? " - Buyer/Seller Group" : ""
              }`}
            >
              {`${selectedGroup?.name}${
                selectedGroup?.isBuyerSellerGroup ? " - Buyer/Seller Group" : ""
              }`}
            </Typography>
          </Box>
          {(isPreviewOpen ||
            (selectedGroup?.isGroup && !showStarMessage && selectedTopic) ||
            (selectedGroup?.isGroup && showStarMessage)) && (
            <Box
              maxWidth="35%"
              sx={{
                minWidth: 0,
                flex: "1 1 auto",
              }}
            >
              {isPreviewOpen && (
                <Chip
                  sx={{
                    color: "#ffffff",
                    borderRadius: "16px",
                    fontSize: fontSizeSchemes.font12,
                    fontWeight: 400,
                    border: "1px solid #000000",
                    height: "1.4rem",
                    backgroundColor: colorSchemes.chipIconBlueColor,
                    cursor: "pointer",
                    transition: "background 0.2s",
                    "&:hover": {
                      backgroundColor: colorSchemes.chipIconBlueColor,
                      border: "1px solid #000000",
                      color: "#fff",
                    },
                  }}
                  deleteIcon={
                    <img
                      src={closeLogo}
                      alt="cross"
                      style={{ width: "0.6rem", marginLeft: "0rem" }}
                    />
                  }
                  label={"Preview"}
                  variant="outlined"
                  onDelete={onClosePreview}
                />
              )}
              {!isPreviewOpen && selectedGroup?.isGroup && !showStarMessage && selectedTopic && (
                <Chip
                sx={{
                  color: "#ffffff",
                  borderRadius: "16px",
                  fontSize: fontSizeSchemes.font12,
                  fontWeight: 400,
                  border: "1px solid #000000",
                  height: "1.4rem",
                  backgroundColor: colorSchemes.chipIconBlueColor,
                  cursor: "pointer",
                  transition: "background 0.2s",
                  "&:hover": {
                    backgroundColor: colorSchemes.chipIconBlueColor, // Use a different color to see the effect
                    border: "1px solid #000000",
                    color: "#fff",
                  },
                }}
                deleteIcon={
                  <img
                    src={closeLogo}
                    alt="cross"
                    style={{ width: "0.6rem", marginLeft: "0rem" }}
                  />
                }
                  label={selectedSubtopic ? `${selectedTopic.name} > ${selectedSubtopic.name}` : `${selectedTopic.name}`}
                  variant="filled"
                  onDelete={handleDelete}
                  title={selectedSubtopic ? `${selectedTopic.name} > ${selectedSubtopic.name}` : selectedTopic.name}
                />
              )}
              {!isPreviewOpen && selectedGroup?.isGroup && showStarMessage && (
                <Chip
                sx={{
                  color: "#ffffff",
                  borderRadius: "16px",
                  fontSize: fontSizeSchemes.font12,
                  fontWeight: 400,
                  border: "1px solid #000000",
                  height: "1.4rem",
                  backgroundColor: colorSchemes.chipIconBlueColor,
                  cursor: "pointer",
                  transition: "background 0.2s",
                  "&:hover": {
                    backgroundColor: colorSchemes.chipIconBlueColor, // Use a different color to see the effect
                    border: "1px solid #000000",
                    color: "#fff",
                  },
                }}
                deleteIcon={
                  <img
                    src={closeLogo}
                    alt="cross"
                    style={{ width: "0.6rem", marginLeft: "0rem" }}
                  />
                }
                  label={"Starred Chats"}
                  variant="outlined"
                  onDelete={handleRemoveStarScreen}
                />
              )}
            </Box>
          )}
        </Stack>

      {/* <Box>
        <ChatSearchButton  size="small" variant="contained" onClick={handleSearch}>
          <SmallIcon src={searchIcon} />
        </ChatSearchButton>
      </Box> */}
    </Stack>
  );
};

export default GroupInfoHeader;
